export const gameOptions = [
  {
    name: 'Account Classification',
    active: true
  },
  {
    name: 'Normal Balance',
    active: true
  },
  {
    name: 'Balanced Equation',
    active: true
  },
  {
    name: 'The Principles',
    active: true
  },
  {
    name: 'Accounting Cycle',
    active: false
  }
];

export const accountColumnTitles = {
  'Account Classification': [
    'Assets', 'Liabilities', 'Equity', 'Revenues', 'Expenses'
  ],
  'Classification': [
    'Assets', 'Liabilities', 'Equity', 'Revenues', 'Expenses'
  ],
  'Normal Balance': [
    'Assets', 'Liabilities', 'Equity', 'Revenues', 'Expenses'
  ],
  'Balanced Equation': [
    'Transactions'
  ],
  'The Principles': [
    'Transactions'
  ],
  'Principles': [
    'Transactions'
  ]
};

export const balancedEquationAccountsTexting = [
  'In Level 1, students will analyze each transaction and determine whether a transaction increases or decreases Assets, Liabilities, or Equity',
  'In Level 2, students will analyze each transaction and determine which Balance Sheet element should be debited and credited.',
  'For this level, you\'ll decide the type of decisions your students will make, we recommend selecting all 3 decision types.',
];

export const thePrinciplesAccountsTexting = 'In each level, students will analyze each transaction and decide if it increases, decreases, or has no impact on profits.';

export const decisionTypes = {
  'Account Classification': {
    'class-elements': 'Elements',
    'class-default': 'Accounts',
    'class-tricky': 'Deferral & Contra Account',
    'classified-multistep': 'Classified & Multi-Step',
    'real-public-co': 'Real Companies'
  },
  'Normal Balance': {
    'norm-elements': 'Elements',
    'norm-default': 'Accounts',
    'norm-tricky': 'Deferral & Contra Account'
  },
  'Balanced Equation': {
    'increase-decrease': 'Increase or Decrease',
    'debit-credit2': 'Debits & Credits',
    'accounts-impacted': 'Accounts Impacted',
    'income-statement-impact': 'Income Statement Impact',
    'all-types': 'All Types'
  },
  'The Principles': {
    'revenue-expense': 'Revenue & Expense Recognition',
    'assumptions-principles-constraints': 'Assumptions, Principles, & Constraints',
  }
}

export const roundLabels = ["First round", "Second round", "Third round", "Fourth round"];